import { styled } from "@mui/material"

export const Background = styled('div')`
    height: 100vh;
    width: 100vw;
    background: linear-gradient(135deg, ${({theme}) => theme.palette.primary.main} 0%, ${({theme}) => theme.palette.secondary.main} 100%);
    display: flex;
    justify-content: center;
    align-items: center;
`